import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UserCache } from 'src/app/services/user-cache';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { ValueTextPair, ValueTextPairNumberValue } from 'src/app/shared/models/value-text-pair';

export interface WeekScheduleReportItem {
  drName: string;
  roomName: string;
  position?: string;
  phName?: string;
  isLeave: boolean;
  color: string;
}

@Component({
  selector: 'app-schedule-report',
  templateUrl: './schedule-report.component.html',
  styleUrls: ['./schedule-report.component.css']
})
export class ScheduleReportComponent implements OnInit {

  @ViewChild('reportContainer')
  reportContainer: ElementRef<HTMLDivElement>;

  @Output()
  printed = new EventEmitter<boolean>();

  clinicName: string = UserCache.getLoginUser().ClinicName;
  reportTitle: string = '';

  constructor(
    private localPrintService: LocalPrintService,
    private notification: EasyNotificationService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.reportContainer.nativeElement.innerHTML = '';
  }

  buildDayHeaderCell(weekText: string): string {
    return `
      <th style="border:1px solid #333; padding:4px 2px; font-size:13px; font-family:'細明體'; background-color:#f5f5f5; text-align:center; vertical-align:middle;">
        ${weekText}
      </th>`;
  }

  buildSectionHeaderCell(secText: string): string {
    return `<td style="border:1px solid #333; width:50px; text-align:center; vertical-align:middle; font-size:12px; font-weight:bold; font-family:'細明體'; background-color:#fafafa; padding:3px 2px;">${secText}</td>`;
  }

  buildSectionDayCell(items: WeekScheduleReportItem[]): string {
    let content = '';                                                                                                                  
    if (!items || items.length === 0) {
      return `<td style="border:1px solid #333; vertical-align:top; padding:3px; height:90px;"></td>`;
    }

    items.forEach(item => {
      content += `
        <div style="font-size:11px; font-family:'細明體'; color:${item.color}; line-height:1.3; margin-bottom:1px; word-break:break-all; white-space:normal;">
          ${item.roomName}${item.drName}${item.position ? ' (' + item.position + ')' : ''}${item.isLeave ? '(離職)' : ''}${item.phName ? ' 藥:' + item.phName : ''}
        </div>`;
    });
    return `<td style="border:1px solid #333; vertical-align:top; padding:3px; height:90px;">${content}</td>`;
  }

  getHtml() {
    if (!this.reportContainer) return '';
    return this.reportContainer.nativeElement.innerHTML;
  }

  async onPrint() {
    const printContents = this.getHtml();
    var ret = await this.localPrintService.printHtml(444, this.reportTitle, printContents);
    if (ret.Successed) {
      this.notification.showSuccess(this.reportTitle + '已送出列印!', true);
    } else {
      this.notification.showError(this.reportTitle + '送出列印失敗!');
    }
    this.printed.emit(true);
  }


  fillData(
    startDate: Date,
    reportName: string,
    sectorOfDay: ValueTextPair[],
    week: ValueTextPairNumberValue[],
    getDoctorList: (si: number, di: number) => WeekScheduleReportItem[]
  ) {
    console.log('fillData', startDate, reportName, sectorOfDay, week);
    const dates: Date[] = [];
    for (let i = 0; i < week.length; i++) {
      dates.push(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i));
    }

    this.reportTitle = reportName;

    let headerCells = '<th style="border:1px solid #333; width:80px; background-color:#f5f5f5;"></th>';
    week.forEach((w, wi) => {
      headerCells += this.buildDayHeaderCell(w.text);
    });

    let bodyRows = '';
    sectorOfDay.forEach((sec, si) => {
      let row = this.buildSectionHeaderCell(sec.text);
      week.forEach((w, wi) => {
        row += this.buildSectionDayCell(getDoctorList(si, wi));
      });
      bodyRows += `<tr>${row}</tr>`;
    });

    this.reportContainer.nativeElement.innerHTML = `
      <div style="margin:0 auto; width:21.59cm; padding:0.4cm 0.4cm; box-sizing:border-box;">
        <div style="text-align:center; font-size:18px; font-weight:bold; padding:2px 0; font-family:'細明體';">
          ${this.clinicName}
        </div>
        <div style="text-align:center; font-size:14px; font-weight:bold; padding:2px 0; margin-bottom:2px; font-family:'細明體';">
          ${this.reportTitle}
        </div>
        <table style="width:100%; border-collapse:collapse; table-layout:fixed;">
          <thead><tr>${headerCells}</tr></thead>
          <tbody>${bodyRows}</tbody>
        </table>
      </div>`;
  }
}